const XHR_STATUS_IDLE = 'idle';
const XHR_STATUS_PENDING = 'pending';
const XHR_STATUS_FULFILLED = 'fulfilled';
const XHR_STATUS_REJECTED = 'rejected';

export const XHR_STATUS = {
  idle: XHR_STATUS_IDLE,
  pending: XHR_STATUS_PENDING,
  fulfilled: XHR_STATUS_FULFILLED,
  rejected: XHR_STATUS_REJECTED,
};
// TODO: Move to separate file depend on theme config or snackbar config
export const ALERT_COLOR = {
  [XHR_STATUS_FULFILLED]: 'success',
  [XHR_STATUS_REJECTED]: 'error',
};
